exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pivot {\n  width: 100%;\n  height: 27px;\n  margin-bottom: 30px;\n  font-size: 14px;\n  font-family: \"Geogtq-Md\", Helvetica, Arial, sans-serif;\n  letter-spacing: 0.7;\n}\n\n.pivot .pivotItem {\n  float: left;\n  height: 27px;\n  line-height: 25px;\n  width: auto;\n  margin-right: 20px;\n  cursor: pointer;\n}", ""]);

